import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";
import { UserProfileEdit } from "../user/userProfileEdit";
import { postApiCall, getApiCall, getApiCallPublic } from "./tokenService";
import { CultureResponse } from "../culture/culture";
import { UserCompanies } from "../user/userCompanies";

export interface ISavePushSubscriptionSuccess {
    id: string;
    message: string;
}

export class SavePushSubscriptionSuccess implements ISavePushSubscriptionSuccess {
    id: string;
    message: string;

    constructor();
    constructor(obj: ISavePushSubscriptionSuccess);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.message = obj && obj.message || "";
    }
}

export const savePushSubscription = (pushSubscription: PushSubscription): Promise<SavePushSubscriptionSuccess> => {
    return postApiCall("api/user/pushsubscription", SavePushSubscriptionSuccess, JSON.stringify(pushSubscription));
};

export const removePushSubscriptions = (pushSubscriptionIds: string[]): Promise<ApiSuccess> => {
    return postApiCall("api/user/pushsubscription/remove", ApiSuccess, JSON.stringify(pushSubscriptionIds));
};

export const getUserProfileEdit = (): Promise<UserProfileEdit> => {
    return getApiCall("api/user/profile", UserProfileEdit);
};

export const saveUserProfile = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/user/profilesave", ApiSuccess, JSON.stringify(obj));
};

export const changePassword = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/user/profilechangepassword", SaveSuccess, JSON.stringify(obj));
};

export const getUserCompanies = (): Promise<UserCompanies> => {
    return getApiCall("api/user/companies", UserCompanies);
};

export const getCultureFromCookie = (): Promise<CultureResponse> => {
    return getApiCallPublic("api/culture/cookie", CultureResponse);
};

export const getCultureFromDatabase = (): Promise<CultureResponse> => {
    return getApiCall("api/culture/database", CultureResponse);
};
